module Meevo.Plugins.EmployeeTemplatePromotions {
  "use strict";

  /**
  * Main Section of Employee Profile Change
  */
    export class MainSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<Model.EmployeeTemplatePromotion> {
        public addCopyModel: Model.EmployeeTemplatePromotion;
    constructor(sectionId: number, displayNameContentKey: string, template: string, isPrimarySection: boolean,
      handlesOwnCrud: boolean, baseEndpoint: string, sectionEndpoint: string,
      loggingService: Meevo.Components.Logging.ILoggingService,
      dataService: Meevo.Components.BaseClasses.IDataService,
      protected $translate: angular.translate.ITranslateService,
      protected identityService: Meevo.Components.Common.IIdentityService = null,
      noun: Meevo.Model.NounEnum = null,
      protected employee: Model.DataDetail,
      sectionSecurityKey?:string    ) {

      super(sectionId, displayNameContentKey, template, isPrimarySection, handlesOwnCrud, baseEndpoint, sectionEndpoint, loggingService, dataService, identityService, noun,null,sectionSecurityKey);
    }

    /**
      * Base class override which defines what a DEFAULT model looks like.
      */
    createSectionModelInstance(postAdd: (data:any) => any): void {
      var params: any = { employeeId: this.employee.id };
      this.dataService.getTemplate(this.baseEndpoint, null, null, params).then((data) => {
        this.model = data;
        this.model.displayName = this.createPromotionDisplayName();
          postAdd(data);
          this.addCopyModel = angular.copy(this.model);
      });
    }

    activate(): void {
      // Initialize model properties
        this.model.employeeCategoryDetail = undefined
        super.activate();
    }

    /**
     * Constructs promotion display name based on employee detail
     */
    public createPromotionDisplayName(): string {
      return Model.Guard.isSomething(this.model)
        ? this.model.displayName = `${this.model.employeeDetail.displayName} - ${this.$translate.instant("LABEL_ACTIVE_ON")} ${moment(this.model.activeDate).format('l')}`
        : null;
    }

    get isCategoryRequired(): boolean {
      return Model.Guard.isSomething(this.model) 
        && Model.Guard.isSomething(this.model.employeeCategories)
        && this.model.employeeCategories.length === 0;
       }

    addEmployeeCategotry(): void {
      if (this.model.employeeCategoryDetail !== undefined
        && _.find(this.model.employeeCategories, (ec) =>
        { return ec.displayName === this.model.employeeCategoryDetail.displayName }) === undefined) {
        {
          this.model.employeeCategories.push(this.model.employeeCategoryDetail);
          this.model.employeeCategoryDetail = undefined;
        }
      }
    }

    removeEmployeeCategory(index: number): void {
      this.model.employeeCategories.splice(index, 1);
    }
   
  }

}